import React, { Component } from 'react';

//components
import CustomButton from "../../../../generic_components/components/buttons/CustomButton";
import { Captcha } from 'primereact/captcha';
import TextBox from "../../../../generic_components/components/input_boxes/TextBox";
import LoadingPgTemplate from "../../../../generic_components/view/LoadingPgTemplate";

//generic functions
import {
    isEmpty,
    cloneObject
} from "../../../../functions/generic_functions";

//regex email string
import {
    emailRegex
} from "../../../../static_data/static_strings";

//router
import { withRouter } from 'react-router-dom';

//static routes
import {
    cari_home_pg_url,
    cari_api_auth_email_url,
    cari_create_account_url,
} from "../../../../router/static_routes";


//redux
import { connect } from "react-redux";
import {
    openCariModal,
} from "../../../../redux/actions/indexActions";

//redux mapper
const mapDispatchToProps = dispatch => {
    return {
        openCariModal: (modal_data) => {
            dispatch(openCariModal(modal_data))
        },
    };
};

class CariLoginPg extends Component {

    state = {
        fetchApiInProgress: false,
        pageLoaded: false,

        reCaptchaVerified: false, //TODO set to false later

        postData: {
            email: "",
        }
    }

    constructor(props) {
        super(props);

        //refs
        this.captchaRef = React.createRef();

        //captcha response
        this.handleOnClickCaptchaResponse = this.handleOnClickCaptchaResponse.bind(this);
        this.handleOnExpireCaptchaResponse = this.handleOnExpireCaptchaResponse.bind(this);

        //click handlers
        this.handleOnChangeSetParentState = this.handleOnChangeSetParentState.bind(this);
        this.handleOnClickSignIn = this.handleOnClickSignIn.bind(this);
        this.handleOnClickCreateAccount = this.handleOnClickCreateAccount.bind(this);

        //auth account
        this.callApiAuthenticateEmail = this.callApiAuthenticateEmail.bind(this);

        //helper functions
        this.checkIfValidEmailRegex = this.checkIfValidEmailRegex.bind(this);
        this.resetCaptcha = this.resetCaptcha.bind(this);
    }

    handleOnClickCaptchaResponse() {
        this.setState({
            reCaptchaVerified: true
        })
    }

    handleOnExpireCaptchaResponse() {
        this.setState({
            reCaptchaVerified: false
        })
    }

    checkIfValidEmailRegex(test_str) {
        var pattern = new RegExp(emailRegex);
        return pattern.test(test_str);
    }

    resetCaptcha() {
        this.captchaRef.current.reset();
        this.setState({
            reCaptchaVerified: false
        })
    }

    /*
        sign in and create account both call the same api, redirect to verification login page or popup error modal for issues
        post parameters {
            email
        }
        return data {
            status => true/false
            message {
                accountExists: true/false
            }
        }
    */
    callApiAuthenticateEmail() {

        var currentEmail = this.state.postData.email;
        var copyPostData = cloneObject(this.state.postData);    

        //if no input
        if (isEmpty(currentEmail)) {
            this.props.openCariModal({
                modalId: "errorModal",
                title: "The input is empty, please try again.",
                callBackFuncOnOk: () => {
                    this.resetCaptcha();
                }
            });
        }
        //invalid email format
        else if (!this.checkIfValidEmailRegex(currentEmail)) {
            this.props.openCariModal({
                modalId: "errorModal",
                title: "Invalid Email Address, please try again.",
                callBackFuncOnOk: () => {
                    this.resetCaptcha();
                }
            });
        }
        //send request
        else {
            var form_data = new FormData();

            //add form data
            for (var postDataKey in copyPostData) {
                form_data.append(postDataKey, copyPostData[postDataKey]);
            }
            
            //shows loading icon
            this.setState({
                fetchApiInProgress: true
            })

            //post request to verify email
            fetch(cari_api_auth_email_url, {
                method: 'POST',
                body: form_data,
                headers: {
                    'Accept': 'application/json',
                }
            }).then((response) => {
                //only continue fetch if mounted
                if (this.state.mounted) {
                    var responseHttpCode = response.status;
                    //good request
                    if (responseHttpCode === 200) {
                        return response.json();
                    }
                    //bad request
                    else {
                        //closes loading icon on finish api
                        this.setState({
                            fetchApiInProgress: false
                        })

                        this.props.openCariModal({
                            modalId: "errorModal",
                            title: "Bad Request, please try again.",
                            callBackFuncOnOk: () => {
                                this.resetCaptcha();
                            }
                        });
                    }
                }
            }).then(json => {

                //successfully processed request
                if (!isEmpty(json)
                    && !isEmpty(json.status)
                    && json.status
                    && !isEmpty(JSON.parse(json.message))
                    && !isEmpty(JSON.parse(json.message).accountExists)
                ) {
                    var json_data = JSON.parse(json.message);
                    var accountExists = json_data.accountExists;

                    //closes loading icon on finish api
                    this.setState({
                        fetchApiInProgress: false
                    })

                    //if the account exists, redirect them to verification page
                    if(accountExists) {
                        //redirect to page with email address as parameter
                        this.props.history.push(cari_home_pg_url + "/" + currentEmail)
                    }
                    //if the account does not exist, redirect to create account page
                    else {  
                        //redirect to page with email address as parameter
                        this.props.history.push(cari_create_account_url + "/" + currentEmail)
                    }
                }
                //if api returns no data
                else {
                    //closes loading icon on finish api
                    this.setState({
                        fetchApiInProgress: false
                    })

                    this.props.openCariModal({
                        modalId: "errorModal",
                        title: "Failed to retrieve data, please try again.",
                        callBackFuncOnOk: () => {
                            this.resetCaptcha();
                        }
                    });
                }
            })
            //if api is not found
            .catch((error) => {
                //closes loading icon on finish api
                this.setState({
                    fetchApiInProgress: false
                })

                console.log(error);
                this.props.openCariModal({
                    modalId: "errorModal",
                    title: "Something went wrong, please try again.",
                    callBackFuncOnOk: () => {
                        this.resetCaptcha();
                    }
                });
            })
        }
    }

    //handles clicks of signin and create
    handleOnClickSignIn() {
        this.callApiAuthenticateEmail();
    }
    handleOnClickCreateAccount() {
        this.callApiAuthenticateEmail();
    }

    //handles change event on set form input data to state
    handleOnChangeSetParentState(value, nameKey) {
        var copyPostData = cloneObject(this.state.postData);    
        if (copyPostData[nameKey] !== undefined) {
            copyPostData[nameKey] = value;
        }
        //set data
        this.setState({
            postData: copyPostData,
        });
    }

    componentDidMount() {
        this.setState({
            mounted: true,
            pageLoaded: true
        });
    }

    componentWillUnmount() {
        this.setState({
            mounted: false
        });
    }

    render() { 
        return (
            <div className={"login_page_format " + ((!this.state.pageLoaded) ? "display_none" : "")}>

                <div className="login_page_layout"> 
                    <img className="beedie_logo_padding_style" src="/new_beedie_logo.png"></img>
                </div>

                <br/>
                
                <div className="login_page_layout"> 
                    <p className="login_text_style">
                        Academic Recruitment Application Login
                    </p>
                </div>

                <div className="login_page_layout"> 
                    <TextBox
                        inputType={"email"}
                        value={this.state.postData.email}
                        name={"email"}
                        label={"Email"}
                        required={true}
                        placeholder={"Email Address"}
                        onChangeSetParentState={this.handleOnChangeSetParentState}
                        maxLength={100}
                        className={"input_box_format"}
                        notAllowedCharacter={" "}
                    />
                </div>

                <br/>

                <div className={(this.state.fetchApiInProgress) ? "display_none" : ""}>
                    <div className="login_page_layout"> 
                        <div className={"captcha_format"}>
                            {this.state.pageLoaded ?
                                <Captcha
                                    ref={this.captchaRef}
                                    //siteKey="6LeyBH8UAAAAADPnB0nxywQOnr8dH-oJiSPYuqYa"
                                    siteKey="6Le2YB4oAAAAABT_C48jYaOvDJKag5h7Qa6C8Lfo"
                                    onResponse={this.handleOnClickCaptchaResponse}
                                    onExpire={this.handleOnExpireCaptchaResponse}
                                />
                                : null
                            }
                        </div>
                    </div>

                    <div className="login_page_layout">
                        <div>
                            <CustomButton
                                disabled={process.env.REACT_APP_ENV === "production"? !this.state.reCaptchaVerified : false}
                                label={"Sign in"}
                                className={"p-button-sfu-red cari_position_action_btn_size"}
                                btnRaised={true}
                                onClickSetParentState={this.handleOnClickSignIn}
                            />
                        </div>

                        <br/>
                       
                        <div>
                            <CustomButton
                                disabled={!this.state.reCaptchaVerified}
                                label={"Create Account"}
                                className={"p-button-sfu-red cari_position_action_btn_size"}
                                btnRaised={true}
                                onClickSetParentState={this.handleOnClickCreateAccount}
                            />
                        </div>
                    </div>
                </div>         

                <div className="login_page_layout"> 
                    <p className="login_issue_text">Should you have any questions or issues, please contact the Dean's Office, Beedie School of Business, at aacoord@sfu.ca</p>
                </div>

                {(this.state.fetchApiInProgress) ?
                    <LoadingPgTemplate />
                    : null}
            </div>
        );
    }
}
export default withRouter(connect(null, mapDispatchToProps)(CariLoginPg));